import type { ISpaceValidation } from "./spaceValidationsUtils";

// Air flow and standard-room checks still count in validation results, but not in coloring.
export const spatialValidationsAreValid = (validations: ISpaceValidation[]): boolean =>
  validations.every(
    (validation) => validation.typeOfValidation !== "SPATIAL" || validation.status === "VALID"
  );
